import {Badge, Card, CardBody, Col, Container, Row} from "reactstrap";
import React from "react";

export default function PrivacyPolicy() {
    const lastUpdated = "June 15, 2026";
    const contactEmail = "zekaryastadele@adraethiopia.org";
    const accountDeleteAfterDays = 10;

    return (
        <Container className="">
            <section className="section section-lg position-relative overflow-hidden"
                     style={{
                         paddingTop: '50px',
                         paddingBottom: '50px',
                         background: 'linear-gradient(180deg, #065C53 0%, #1a7a6e 60%, #2a8f82 100%)'
                     }}>

            </section>
            <Row className="justify-content-center">
                <Col md="10" lg="8">
                    <Card className="shadow-sm border-0">
                        <CardBody className="p-4 p-md-5">
                            <div className="mb-4">
                                <h1 className="display-4 font-weight-bold text-dark">Privacy Policy</h1>
                                <p className="text-muted small">Effective Date: {lastUpdated}</p>
                                <hr/>
                            </div>

                            <section className="mb-5">
                                <p>
                                    This privacy policy applies to the <strong>On Energy Connect</strong> app (the
                                    "Application")
                                    for mobile devices. This Application was created by <strong>ADRA
                                    Ethiopia</strong> (the "Service Provider")
                                    as a Free service. This service is intended for use "AS IS".
                                </p>
                            </section>

                            <h3 className="h4 font-weight-bold mb-3">1. Information Collection and Use</h3>
                            <p>
                                To facilitate employment linkages in the energy sector, the Application requires account
                                creation.
                                The following information is collected:
                            </p>
                            <ul className="mb-4">
                                <li><strong>Account Credentials:</strong> Username, Gender, phone number, email address,
                                    and
                                    password.
                                </li>
                                <li><strong>Professional Profile:</strong> Name, phone number, location, profile
                                    picture, and technical
                                    certifications (CV).
                                </li>
                            </ul>

                            <h3 className="h4 font-weight-bold mb-3">2. Third Party Access</h3>
                            <p>
                                We do not sell, rent, or share your personal information with third parties.
                            </p>

                            <p>
                                Where you choose to enable optional features, such as Telegram
                                notifications, limited information necessary to provide those services may
                                be transmitted through the relevant third-party provider.
                            </p>

                            <p>
                                The use of third-party services is limited to facilitating communication and
                                delivering notifications requested by the user.
                            </p>

                            <h3 className="h4 font-weight-bold mb-3">3. Account Deletion & Data Rights</h3>
                            <p>
                                You have the right to request the permanent deletion of your account and
                                associated personal data.
                            </p>

                            <div className="p-3 mb-4 bg-light border rounded">
                                <Badge color="primary" className="mb-2">
                                    How to Delete Your Account
                                </Badge>

                                <ol className="mb-3 pl-3">
                                    <li>Open the <strong>Profile</strong> screen.</li>
                                    <li>Scroll to the bottom and select <strong>Delete Account</strong>.</li>
                                    <li>
                                        Tap <strong>Request Account Deletion</strong> and confirm your
                                        request.
                                    </li>
                                </ol>

                                <p className="mb-0">
                                    Once confirmed, your account will be scheduled for deletion. The
                                    deletion process will be completed
                                    within <strong>{accountDeleteAfterDays} days</strong> of
                                    the request.
                                </p>
                            </div>

                            <p>
                                During the 10-day period, you may cancel the deletion request from the same
                                screen if you change your mind.
                            </p>

                            <p>
                                After the deletion is completed, you will no longer be able to access your
                                account. Your profile, uploaded documents, and personally identifiable
                                information will be removed from our active databases.
                            </p>

                            <p>
                                If you require assistance with account deletion, you may contact the
                                Service Provider directly via email at{" "}
                                <a
                                    href={`mailto:${contactEmail}`}
                                    className="font-weight-bold text-primary"
                                >
                                    {contactEmail}
                                </a>.
                            </p>

                            <h3 className="h4 font-weight-bold mb-3">4. Data Retention Policy</h3>
                            <p>
                                We retain your information for as long as your account remains active.
                            </p>

                            <p>
                                If you request account deletion, your account will be marked for deletion
                                and permanently removed within <strong>{accountDeleteAfterDays} days</strong>, unless
                                you cancel
                                the request during that period.
                            </p>

                            <p>
                                Please note that uninstalling the Application from your device does not
                                automatically delete your account or personal information stored on our
                                servers.
                            </p>

                            <h3 className="h4 font-weight-bold mb-3">5. Children's Privacy</h3>
                            <p>
                                This Application is intended for professionals and does not knowingly collect data
                                from children under the age of 13.
                            </p>

                            <h3 className="h4 font-weight-bold mb-3">6. Security</h3>
                            <p>
                                We provide electronic and procedural safeguards to protect the confidentiality
                                of the information we process and maintain.
                            </p>

                            <hr className="my-5"/>

                            <footer className="text-center">
                                <h5 className="font-weight-bold">Questions or Concerns?</h5>
                                <p>Please reach out via email:</p>
                                <a href={`mailto:${contactEmail}`} className="btn btn-outline-primary px-4">
                                    Contact Service Provider
                                </a>
                            </footer>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};